import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../Common/LoadingSpinner';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const { forgotPassword } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await forgotPassword(email);
            setSubmitted(true);
            toast.success(response.message || 'Password reset link sent to your email');
        } catch (error) {
            toast.error(error.response?.data?.message || error.message || 'Failed to send reset link');
            console.error('Forgot password error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="floating-shapes">
                {[...Array(6)].map((_, i) => (
                    <div key={i} className="floating-shape"></div>
                ))}
            </div>

            <div className="wave-container">
                <div className="wave"></div>
                <div className="wave"></div>
                <div className="wave"></div>
            </div>

            <div className="auth-container">
                <div className="auth-card">
                    <div className="auth-header">
                        <div className="logo">
                            <img src="/logo.svg" alt="MessagePe" className="auth-logo-img" />
                        </div>
                        <h2>Forgot Password</h2>
                        <p>
                            {submitted
                                ? "Check your email for the reset link"
                                : "Enter your email to receive a password reset link"}
                        </p>
                    </div>

                    {!submitted ? (
                        <form className="auth-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="email" className="form-label">Email Address</label>
                                <input
                                    type="email"
                                    id="email"
                                    className="form-control"
                                    placeholder="name@example.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    disabled={loading}
                                />
                            </div>

                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? <LoadingSpinner size="small" /> : 'Send Reset Link'}
                            </button>
                        </form>
                    ) : (
                        <div className="success-message" style={{ textAlign: 'center', margin: '20px 0' }}>
                            <i className="fas fa-check-circle" style={{ fontSize: '48px', color: '#25D366', marginBottom: '15px' }}></i>
                            <p>We've sent an email to <strong>{email}</strong> with instructions to reset your password.</p>
                            <button
                                className="btn btn-secondary"
                                style={{ marginTop: '20px' }}
                                onClick={() => setSubmitted(false)}
                            >
                                Use a different email
                            </button>
                        </div>
                    )}

                    <div className="auth-footer">
                        <p>Back to <Link to="/login">Sign In</Link></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
